import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useTrueAtMediaBreakpointLessThen } from '@costar-ui/hooks';
import React, { useMemo } from 'react';
import { composeRenderProps } from 'react-aria-components';
import _Tooltip from './aria/tooltip.esm.js';
import TooltipTrigger from './aria/tooltip-trigger.esm.js';
import { tooltipStyles } from './tooltip.styles.esm.js';
import Card from '../card/card.esm.js';
import OverlayArrow from '../overlay-arrow/overlay-arrow.esm.js';
import { PrivatePopover } from '../popover/popover.esm.js';
import PopoverContextProvider from '../popover/popover-context.esm.js';

var _excluded = ["isOpen", "defaultOpen", "onOpenChange", "isDisabled", "delay", "closeDelay", "trigger", "className", "children", "color", "radius", "anchorElement", "maxWidth", "offset", "placement", "padding"];
function Tooltip(_ref) {
  var isOpen = _ref.isOpen,
    defaultOpen = _ref.defaultOpen,
    onOpenChange = _ref.onOpenChange,
    isDisabled = _ref.isDisabled,
    delay = _ref.delay,
    closeDelay = _ref.closeDelay,
    trigger = _ref.trigger,
    _ref$className = _ref.className,
    _className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'base' : _ref$color,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 'base' : _ref$radius,
    anchorElement = _ref.anchorElement,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 500 : _ref$maxWidth,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 8 : _ref$offset,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? '3xl' : _ref$padding,
    props = _objectWithoutProperties(_ref, _excluded);
  //This has to be memoized, a new jsx prop would incur multiple rerenders on context provider update
  var contextValue = useMemo(function () {
    return {
      color: color,
      radius: radius,
      padding: padding // no need to apply padding to the tooltip container only the card container
    };
  }, [color, radius, padding]);
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classes = tooltipStyles(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        className: className,
        color: color,
        radius: radius
      }));
      return "csg-tw-tooltip ".concat(classes);
    });
  }, [color, radius, _className]);

  // @ts-ignore
  var style = useMemo(function () {
    return {
      '--max-tooltip-width': "".concat(maxWidth, "px")
    };
  }, [maxWidth]);
  var isMobile = useTrueAtMediaBreakpointLessThen('sm'); // less then 640px is considered mobile
  return isMobile ? /*#__PURE__*/React.createElement(PrivatePopover
  // @ts-ignore
  , _extends({
    className: _className,
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    anchorElement: anchorElement,
    showArrow: true,
    color: color,
    radius: radius,
    maxWidth: maxWidth,
    offset: offset,
    placement: placement
  }, props), /*#__PURE__*/React.createElement(Card, {
    bordered: false,
    canShrink: true,
    padding: padding
  }, /*#__PURE__*/React.createElement(Card.Body, {
    canShrink: true
  }, children))) : /*#__PURE__*/React.createElement(PopoverContextProvider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(TooltipTrigger, {
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    isDisabled: isDisabled,
    delay: delay,
    closeDelay: closeDelay,
    trigger: trigger
  }, anchorElement, /*#__PURE__*/React.createElement(_Tooltip, _extends({
    placement: placement,
    offset: offset,
    className: classes,
    style: style
  }, props), /*#__PURE__*/React.createElement(OverlayArrow, null), /*#__PURE__*/React.createElement(Card, {
    bordered: false,
    canShrink: true,
    padding: padding
  }, /*#__PURE__*/React.createElement(Card.Body, {
    canShrink: true
  }, children)))));
}

export { Tooltip as default };
//# sourceMappingURL=tooltip.esm.js.map
